<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space"><span class="text">{{ msgAlerta }}</span></div>


    <div v-show="!modoEdicao && !modoAbertura  && !showDocView">
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Modelo Selecionado</label>
                    <div class="field-label field-label--destaque">{{ modeloSelecionado?.nmepdocmodelo }}</div>
                </div>
                
                <div class="form-item-char10">
                    <label class="label-caption">Versão Atual</label>
                    <div class="field-label field-label-center field-label--destaque">{{ modeloSelecionado?.versao }}</div>
                </div>
            </div>
            <div class="row row-space">
                <div class="form-item-rangedata"><RangeDataSelect :periodoInicial="'currentMonth'" v-model="dateRange" /></div>

                <div class="form-item">
                    <div v-if="globalStore.idestabelecimento">
                        <label class="label-caption">Estabelecimento</label>
                        <div class="field-label">{{ globalStore.nmestabelecimento }}</div>
                    </div>
                    <div v-else>
                        <EstabelecimentoSelect v-model:idSelecionado="estabelecimentoSelecionado" />
                    </div>
                </div>

                <button type="button" class="buttom-icon--search" @click="lerDados" />
                <button type="button" class="buttom-icon--add" @click="setAberturaProcesso" />
                <button type="button" class="buttom-icon--close" @click="closeForm" />
            </div>
        </div>

        <div v-if="lsDados.length>0" class="table-wrapper">
            <table>
                <thead><tr>
                    <th>Data</th>
                    <th>Protocolo</th>
                    <th>S.I.M.</th>
                    <th>Estabelecimento</th>
                    <th>Nro SIM</th>
                    <th>Situação</th>
                </tr></thead>

                <tbody>
                    <tr v-for="(obj, index) in lsDados" :key="obj.idregistro" @click="onClickItem(obj)"
                    :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                        <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtdoc) }}</td>
                        <td class="col-width-char20">{{ obj.protocolo }}</td>
                        <td class="col-width-char20">{{ obj.nmsim }}</td>
                        <td>{{ obj.nmestabelecimento }}</td>
                        <td class="col-width-char20">{{ obj.nrosim }}</td>
                        <td class="col-width-char20">{{ obj.nmstatus }}</td>
                    </tr>
                </tbody>
            </table>



            <div v-if="showPagination" class="pagination">
                <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
                <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
                <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
            </div>
        </div>
    </div>


    <div v-if="modoAbertura">
        <div class="form-edit-page">
            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Modelo Selecionado</label>
                    <div class="field-label field-label--destaque">{{ modeloSelecionado?.nmepdocmodelo }}</div>
                </div>
                
                <div class="form-item-char10">
                    <label class="label-caption">Versão Atual</label>
                    <div class="field-label field-label-center field-label--destaque">{{ modeloSelecionado?.versao }}</div>
                </div>
                
                <div class="form-item-char20">
                    <label class="label-caption">Data da Versão</label>
                    <div class="field-label field-label-center field-label--destaque">{{ Funcoes.formatDateFromJson(modeloSelecionado?.versao_data) }}</div>
                </div>
            </div>


            <div v-if="globalStore.idsim" class="row row-space">
                <div class="form-item">
                    <label class="label-caption">S.I.M.</label>
                    <div class="field-label field-label--destaque">{{ globalStore.nmsim }}</div>
                </div>
            </div>
            <div v-else-if="modeloSelecionado?.cksim!='N'" class="row row-space">
                <div class="form-item">
                    <SimSelect v-model:idSelecionado="novoIdSim"></SimSelect>
                </div>
            </div>


            <div v-if="globalStore.idestabelecimento" class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Estabelecimento</label>
                    <div class="field-label field-label--destaque">{{ globalStore.nmestabelecimento }}</div>
                </div>
                
                <div class="form-item-char40">
                    <label class="label-caption">Atividade</label>
                    <div class="field-label field-label--destaque">{{ globalStore.atividade.nmatividade }}</div>
                </div>
            </div>
            <div v-else-if="modeloSelecionado?.ckestabelecimento!='N'" class="row row-space">
                <div class="form-item">
                    <EstabelecimentoSelect
                        v-model:idSelecionado="novoIdEstabelecimento"
                        v-model:objSelecionado="estabelecimentoDocSelecionado">
                    </EstabelecimentoSelect>
                </div>
                
                <div class="form-item-char50">
                    <label class="label-caption">Atividade</label>
                    <div class="field-label field-label--destaque">{{ estabelecimentoDocSelecionado?.nmatividade }}</div>
                </div>
            </div>
            

            <div class="row-start">
                <div class="form-item-data">
                    <label class="label-caption" >Data</label>
                    <input type="date" v-model="edDtDoc" />
                </div>

                <button class="btn-confirm" @click="gerarDoc">Abrir Protocolo</button>
                <button @click="modoAbertura=false">Retornar</button>
            </div>
        </div>
    </div>


    <div v-if="modoEdicao">
        <DocEditPage :idEdicao="idEdicao" @close="modoEdicao = false" @save="lerDados" />
    </div>


    <AssinaturaPendenteListaModal
        v-if="showModalAssinaturas"
        :refId="idDocSelecionado"
        :refTable="'DOC'"
        @close="showModalAssinaturas = false"
    />

    <template v-if="showDocView">
        <DocViewPage :idView="idDocSelecionado" @close="showDocView = false" @save="lerDados" />
    </template>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes.js';
import AssinaturaPendenteListaModal from '@/components/modals/AssinaturaPendenteListaModal.vue';
import DocEditPage from '../formularios/DocEditPage.vue';
import DocViewPage from '@/views/docs/visualizacoes/DocViewPage.vue';
import EstabelecimentoSelect from '@/components/selects/EstabelecimentoSelect.vue';
import SimSelect from '@/components/selects/SimSelect.vue';
import RangeDataSelect from '@/components/selects/RangeDataSelect.vue';

const props = defineProps({idModelo: Number});

const idDocSelecionado = ref(0);
const showModalAssinaturas = ref(false);
const showDocView = ref(false);

const edDtDoc = ref(null);
const novoIdSim = ref(globalStore.idsim);
const novoIdEstabelecimento = ref(globalStore.idestabelecimento);

const estabelecimentoSelecionado = ref(null);
const estabelecimentoDocSelecionado = ref(null);
const modeloSelecionado = ref(null);

const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const emit = defineEmits(['close']);
const idEdicao = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const modoAbertura = ref(false);
const modoEdicao = ref(false);
const msgAlerta = ref(null);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);

const closeForm = () => {emit('close');}


async function gerarDoc(){
    let x = '';
    if (modeloSelecionado.value.cksim==='S' && !novoIdSim.value) x+='\n-Informe o S.I.M.';
    if (modeloSelecionado.value.ckestabelecimento==='S' && novoIdEstabelecimento.value<1) x+='\n-Informe o Estabelecimento';
    if (novoIdSim.value && novoIdEstabelecimento.value && novoIdSim.value != estabelecimentoDocSelecionado.value.idsim){
        x +='\n-Estabelecimento não pertence ao S.I.M. selecionado';
    }

    let r = Validar.data(edDtDoc.value, -500);
    if (!r.ok) x += '\n-Informe corretamente a data do documento';

    if (x){
        msgAlerta.value = `ATENÇÃO:${x}`;
        return;
    }
    try{
        isLoading.value = true;
        msgAlerta.value = null;
        const payload = {
            nmrequisicao: "SPDOC_GERAR",
            idep: globalStore.idep,
            idsim: novoIdSim.value,
            idestabelecimento: novoIdEstabelecimento.value,
            idreferencia: modeloSelecionado.value.id,
            datainicial: edDtDoc.value,
            idlogin: globalStore.idlogin};

        const resp = await Api.genericPost('/doc/exec_requisicao', payload);
        if (resp.bolok === 1){
            // CHAMAR ABERTURA DE EDIÇÃO
            lerDados();
            modoAbertura.value=false;
            idEdicao.value = resp.id;
            modoEdicao.value = true;
        } else {
            msgAlerta.value=`ATENÇÃO: ${resp.erro}`;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


async function lerDados() {
    try{
        Funcoes.validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        msgAlerta.value = null;
        isLoading.value = true;
        const dados = {
            idep: globalStore.idep,
            idsim: globalStore.idsim,
            idestabelecimento: ((globalStore.ckperfilestabelecimento) || (globalStore.ckperfilrt)) ? globalStore.idestabelecimento : estabelecimentoSelecionado.value,
            idreferencia: modeloSelecionado.value.id,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate};
        const req = await Api.genericPost('/lsdoc/doc', dados);
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


async function lerModelos() {
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/epdocmodelo', {id: props.idModelo, idep: globalStore.idep, ativo: "S"});
        modeloSelecionado.value = req[0];
        lerDados();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


function onClickItem(obj){
    if (obj.cdstatus==1){
        idEdicao.value=obj.id;
        modoEdicao.value=true;
    }else if (obj.cdstatus==7){
        if (!showDocView.value){
            idDocSelecionado.value = obj.id;
            showDocView.value = true;
        }else{
            visualizarLaudo(obj);
        }
    }else{
        idDocSelecionado.value = obj.id;
        showDocView.value = true;
        // idDocSelecionado.value = obj.id;
        // showModalAssinaturas.value=true;
    }
}


function setAberturaProcesso(){
    novoIdSim.value = globalStore.idsim;
    novoIdEstabelecimento.value = globalStore.idestabelecimento;
    modoAbertura.value = true;
}


const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}


async function visualizarLaudo(obj) {
    try {
        if (!obj.idlaudo) throw new Error('Laudo não disponível');
        msgAlerta.value = null;
        isLoading.value = true;        
        const response = await Api.genericAnexo(obj.idlaudo);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


onMounted(lerModelos)
</script>